<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />
  <div v-else class="animated fadeIn">
    <default-heading text="Shared Results Detail" class="mt-3">
      <template #right>
        <b-button
          variant="primary"
          class="ml-1"
          to="/results-sharing"
        >
          <i class="fal fa-list" />
        </b-button>

        <b-button
          variant="warning"
          class="ml-1 text-white"
          :to="`/results-sharing/${result_sharing_id}/edit`"
        >
          <i class="fal fa-pencil" />
        </b-button>

        <b-button
          variant="danger"
          class="ml-1"
          @click="showDeleteModal"
        >
          <i class="fal fa-trash" />
        </b-button>
      </template>
    </default-heading>

    <div class="mt-3" />

    <div>
      <b-card>
        <div>
          <b-table-lite
            :items="resultSharingInfoRows"
            striped
            small
            bordered
            thead-class="d-none"
          />
        </div>
      </b-card>

      <h3>Shared Results</h3>
      <ResultServerTable :collection="result_collection" />
    </div>
  </div>
</template>

<script>
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import DefaultHeading from '@/components/shared/DefaultHeading'
import ResultSharingModel from '@/models/result/ResultSharingModel'
import ResultServerTable from '@/components/modus/result/ResultServerTable'
import ResultCollection from '@/collections/result/ResultCollection'

export default {
  name: 'ResultSharingDetail',
  components: {
    LoadingOverlay,
    DefaultHeading,
    ResultServerTable
  },
  data() {
    return {
      loading: true,
      result_sharing_id: this.$route.params.id,
      result_sharing: null,
      result_collection: null
    }
  },
  computed: {
    resultSharingInfoRows () {
      const rows = []

      if (this.result_sharing) {
        rows.push(
          {
            label: 'Shared With',
            value: this.result_sharing.share_code
          },
          {
            label: 'Sample Type',
            value: this.result_sharing.sample_type && this.result_sharing.sample_type.name
          },
          {
            label: 'Grower',
            value: this.result_sharing.grower
          },
          {
            label: 'Field',
            value: this.result_sharing.field
          },
          {
            label: 'Zone',
            value: this.result_sharing.zone
          },
          {
            label: 'Crop',
            value: this.result_sharing.crop_type
          },
          {
            label: 'Crop Stage',
            value: this.result_sharing.crop_stage
          },
          {
            label: 'Status',
            value: this.result_sharing.status
          },
          {
            label: 'Shared From',
            value: this.result_sharing.starts_at
          },
          {
            label: 'Shared To',
            value: this.result_sharing.ends_at || 'Ongoing'
          }
        )
      }

      // filter out rows with no value
      return rows.filter(row => row.value)
    }
  },
  mounted () {
    this.fetchResultSharing()
  },
  methods: {
    async fetchResultSharing () {
      const model = new ResultSharingModel({ id: this.result_sharing_id })
      const params = {}
      params.connection = ['sample_type']
      model.fetch({ params }).then(() => {
        this.result_sharing = model

        const collection = new ResultCollection()
        const filter = collection.getFilter()
        filter.filterEquals('resultCustomers.result_share_id', this.result_sharing_id)
        filter.cacheStaticFilters()
        this.result_collection = collection

        this.loading = false
      })
    },

    showDeleteModal () {
      this.$bvModal.msgBoxConfirm('Deleting this share definition will revoke access to all results shared by it. Are you sure you want to proceed?', {
        title: 'Revoke Access',
        modalClass: ["modal-danger"],
        size: "sm",
        okVariant: "danger",
        okTitle: "YES",
        cancelTitle: "NO",
        footerClass: "p-2",
        centered: true,
      })
      .then(confirm => {
        if (confirm) {
          const model = new ResultSharingModel({ id: this.result_sharing_id })
          model.delete().then(() => {
            this.$bvToast.toast('', {
              title: 'Result Sharing deleted',
              variant: 'success'
            })

            this.$router.push('/results-sharing')
          })
        }
      })
    }
  }
}
</script>
